export type MerchStatus = "active" | "draft" | "archived";

export const MERCH_STATUS_LABEL: Record<MerchStatus, string> = {
  active: "Active",
  draft: "Draft",
  archived: "Archived",
};

export const MERCH_STATUS_BADGE_CLASSES: Record<MerchStatus, string> = {
  active: "border-emerald-200 bg-emerald-50 text-emerald-700",
  draft: "border-slate-200 bg-slate-50 text-slate-600",
  archived: "border-amber-200 bg-amber-50 text-amber-700",
};

export const MERCH_STATUS_DOT_CLASSES: Record<MerchStatus, string> = {
  active: "bg-emerald-500",
  draft: "bg-slate-400",
  archived: "bg-amber-500",
};

export function toMerchStatus(status?: string | null): MerchStatus {
  return status && status in MERCH_STATUS_LABEL ? (status as MerchStatus) : "draft";
}
